export const decodeRouteParam = (value: string): string => {
  try {
    return decodeURIComponent(value)
  }
  catch {
    return value
  }
}

export const fullyDecodeRouteParam = (value: string): string => {
  try {
    const decoded = decodeURIComponent(value)
    return decoded === value ? value : fullyDecodeRouteParam(decoded)
  }
  catch {
    return value
  }
}

export const normalizeTagValue = (value: string): string =>
  fullyDecodeRouteParam(String(value || ''))
    .trim()
    .replace(/^#+/, '')

export const normalizeRoutePath = (path: string): string =>
  path
    .split('/')
    .map(segment => fullyDecodeRouteParam(segment))
    .join('/')

export const normalizeBrowserPathname = (pathname: string): string =>
  pathname
    .split('/')
    .map(segment => fullyDecodeRouteParam(segment))
    .join('/')
